import { useCallback, useEffect, useState } from 'react';
import { IoSearchSharp } from 'react-icons/io5';
import { MdOutlineRemoveRedEye } from 'react-icons/md';
import HOC from '../../components/HOC/HOC';
import styles from '../../css/style.module.css';

import img2 from '../../assest/loading1.gif';

import { VscSettings } from 'react-icons/vsc';
import { Link, useNavigate, useParams } from 'react-router-dom';
import FilterModal from '../../components/Modals/FilterModal';
import { SuccessfullyModal, ViewUserProfile } from '../../components/Modals/Modals';
import Pagination from '../../components/Pagination/Pagination';
import { getApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';
import { formatDate } from '../../utils/utils';

const columns = [
  'S.no',
  'Order ID',
  'User Name',
  'Date',
  'Sub Total',
  'GST (18%) Amount',
  'Total Price',
  'Assigned Partner',
  'Accepted Assigned Partner',
  'Status',
  'Action',
  'Re order',
];

const UserOrders = () => {
  const { id } = useParams();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showUserprfileModal, setShowUserProfileModal] = useState(false);
  const [userOrderdata, setUserOrderData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [search, setSearch] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('');

  const [pagination, setPagination] = useState({
    limit: 10,
    totalPages: 1,
    page: 1,
    hasPrevPage: false,
    hasNextPage: false,
  });

  const fetchData = useCallback(async () => {
    await getApi(
      endPoints.getallUserOrders(pagination.page, pagination.limit, search, id, selectedFilter),
      {
        setResponse: setUserOrderData,
        setLoading,
        errorMsg: 'Failed to fetch user Orders!',
      }
    );
  }, [pagination.page, pagination.limit, search, id, selectedFilter]);

  useEffect(() => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      totalPages: userOrderdata?.data?.totalPages,
      hasPrevPage: userOrderdata?.data?.hasPrevPage,
      hasNextPage: userOrderdata?.data?.hasNextPage,
    }));
  }, [userOrderdata]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPagination({ ...pagination, page: 1 }); // Reset to the first page on search
  };

  const filterOptions = [
    { label: 'Completed', value: 'Completed' },
    { label: 'Pending', value: 'Pending' },
  ];

  const handleApply = (appliedFilter) => {
    setSelectedFilter(appliedFilter);
    setShowDropdown(false);
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const navigate = useNavigate();

  return (
    <>
      <SuccessfullyModal
        show={showSuccessModal}
        handleClose={() => setShowSuccessModal(false)}
        text="Successfully Deleted"
      />
      <ViewUserProfile
        show={showUserprfileModal}
        data={selectedUser}
        onHide={() => setShowUserProfileModal(false)}
      />
      <div className={styles.jobmanagementCotainer}>
        <div className={styles.jobtoppart}>
          <div className={styles.pagetitle}>
            <h6>User Order</h6>
            <div className={styles.searchbarnav}>
              <IoSearchSharp color="#8A8A8A" size={20} />
              <input
                type="search"
                placeholder="Search"
                value={search}
                onChange={handleSearchChange}
              />
            </div>
            <div className={styles.rightbuttons}>
              <div className={styles.rightbuttons2} onClick={() => navigate('/user-management')}>
                <p>Back</p>
              </div>
            </div>
          </div>
          <div className={styles.filterbutton} onClick={toggleDropdown}>
            <VscSettings color="#737373" size={20} />
            <p>Filters</p>
          </div>
          {showDropdown && (
            <FilterModal
              handleApply={handleApply}
              filterOptions={filterOptions}
              selectedFilter={selectedFilter}
            />
          )}
        </div>
        <div className={styles.jobchildcontainer}>
          <div className={styles.tablecontainer}>
            <table className={styles.table1}>
              <thead>
                <tr>
                  {columns.map((label, index) => (
                    <th key={index} className={styles.tableHeader}>
                      {label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="12" style={{ textAlign: 'center', padding: '1rem' }}>
                      <img src={img2} alt="" width={100} height={100} />
                    </td>
                  </tr>
                ) : userOrderdata?.data?.docs?.length === 0 ? (
                  <tr>
                    <td colSpan="12" style={{ textAlign: 'center', padding: '1rem' }}>
                      No data available.
                    </td>
                  </tr>
                ) : (
                  userOrderdata?.data?.docs?.map((register, rowIndex) => (
                    <tr key={rowIndex} className={styles.tableRow}>
                      <td className={styles.tableCell}>{rowIndex + 1}</td>
                      <td className={styles.tableCell}>{register?.orderId}</td>
                      <td className={styles.tableCell}>
                        {register?.user?.firstName} {register?.user?.lastName}
                      </td>
                      <td className={styles.tableCell}>{formatDate(register?.jobs?.[0]?.date)}</td>
                      <td>₹{register?.subTotal}</td>
                      <td>₹{register?.vat}</td>
                      <td className={styles.tableCell}>₹{register.total}</td>

                      <td className={styles.tableCell} style={{ maxHeight: '130px', overflowY: 'auto', display: 'block' }}>
                        <ul>
                          {register?.staff?.map((itme, rowIndex) => (
                            <li key={rowIndex}>
                              {itme.firstName} {itme.lastName}
                            </li>
                          ))}
                        </ul>
                      </td>
                      <td className={styles.tableCell} >
                        <ul  >
                          {register?.staffAccepted?.map((itme, rowIndex) => (
                            <li key={rowIndex}>
                              {itme.firstName} {itme.lastName}
                            </li>
                          ))}
                        </ul>
                      </td>
                      <td
                        className={styles.tableCell}
                        style={{
                          color:
                            register?.jobStatus === 'Pending'
                              ? '#FFA800'
                              : register?.jobStatus === 'Completed'
                              ? '#00AD1D'
                              : 'black',
                          fontWeight: '600',
                        }}
                      >
                        {register?.jobStatus}
                      </td>
                      <td>
                        <div className={styles.tableaction}>
                          <Link to={`/orders/details/${register?._id}`}>
                            <MdOutlineRemoveRedEye size={20} />
                          </Link>
                        </div>
                      </td>
                      <td>
                        <div className={styles.tableaction}>
                          <div className={styles.tablecreatebutton}>
                            <Link to={`/user-management/user-orders/${id}/${register?._id}`}>
                              <button>Reorder</button>
                            </Link>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          <Pagination
            limit={pagination.limit}
            totalPages={pagination.totalPages}
            page={pagination.page}
            hasPrevPage={pagination.hasPrevPage}
            hasNextPage={pagination.hasNextPage}
            onPageChange={(newPage) => setPagination({ ...pagination, page: newPage })}
          />
        </div>
      </div>
    </>
  );
};

export default HOC(UserOrders);
